let zoomPlayer;
const btnZoom = $('.js-btn-video-zoom');
const zoomSrc = videoElementOrig.data('zoom');

function createZoomVideoElement(src) {
    const layout = `<video id='videoPlayerZoom' class='video-js js-video-player-zoom hidden-block' playsinline>
        <source src='${src}' type='video/mp4'>
    </video>`;

    $('.js-video-player-wrapper').prepend(layout);

    $(document).trigger('zoomPlayerElementCreated');
}

if ($('.js-btn-video-zoom').length) {
    createZoomVideoElement(zoomSrc);

    zoomPlayer = $('#videoPlayerZoom').get(0);

    zoomPlayer.addEventListener('canplaythrough', function () {
        isZoomCanPlay = true;
        $(document).trigger('zoomCanPlayEvent');
    });

    $(document).on('playerCanPlayEvent zoomCanPlayEvent', function (event) {
        if (isPlayerCanPlay && isZoomCanPlay) {
            btnZoom.prop('disabled', false);
        }
    });
}
